import * as React from 'react';
import styled from 'styled-components';
import { selectColumnRules, gridSystemStylesContext } from '../grid-system-style-context';
import { IColumnProps } from './column-props';

interface IColumnWrapperProps extends Pick<IColumnProps, 'columnSize'> {
    $columnSize: IColumnProps['columnSize'];
    $rules: any;
}

const ColumnWrapper = styled.div.attrs({
    className: String('ap-grid-column')
}) <IColumnWrapperProps>`
    ${props => props.$rules}
    flex: ${({ $columnSize }) => ($columnSize === undefined ? 1 : '')};
`;

export function Column(props: IColumnProps) {
    const { columnSize, offsetLeft, offsetRight, elementRef, className, hidden } = props;
    const gridSystemStyles = React.useContext(gridSystemStylesContext);
    const rules = selectColumnRules(gridSystemStyles, { columnSize, offsetLeft, offsetRight });
    return hidden ? null : (
        <ColumnWrapper className={className} ref={elementRef} $rules={rules} $columnSize={columnSize}>
            {props.children}
        </ColumnWrapper>
    );
}
